define('all/navigation',['module', 'jquery', 'all/pretty-links', 'all/jquery/jquery.cookie'], function(module, $, prettyLinks) {
	'use strict';

	var configuration = module.config();

	var LAST_PAGE_COOKIE = 'lastProduct';

	var javascriptPrefix = configuration.javascriptPrefix + '/static/shared';
	var contentPrefix = configuration.contentPrefix + '/static/' + configuration.site;
	var dynamicPrefix = configuration.dynamicPrefix.replace(/\/$/, '');

	var baseURL = location.protocol + '//' + location.host;
	var locale = configuration.locale.toLowerCase();
	var language = 'en';

	function staticURL(url) {
		if (!url.match(/^\//)) {
			url = '/' + url;
		}
		return contentPrefix + url;
	}

	function javascriptURL(url) {
		if (!url.match(/^\//)) {
			url = '/' + url;
		}

		url = javascriptPrefix + url;

		if(url.slice(0, 4) !== 'http') {
			return baseURL + url;
		}
		return url;
	}

	function dynamicURL(url) {
		if (!url.match(/^\//)) {
			url = '/' + url;
		}
		return dynamicPrefix + url;
	}

	function updatableImgURL(filename) {
		return contentPrefix + '/img/updatable/' + getLowerUppercaseLocale() + '/' + filename;
	}

	function getLowerUppercaseLocale() {
		var localeSplit = locale.split('_');
		return localeSplit[0] + '_' + localeSplit[1].toUpperCase();
	}

	function gotoLastProductPage() {
		var lastProductPage = $.cookie(LAST_PAGE_COOKIE);

		if (!lastProductPage) {
			lastProductPage = prettyLinks.getLink('CASINO', 'CASINOSTART');
		}

		if (window.top.location.pathname + window.top.location.hash === lastProductPage) {
			window.top.location.reload();
		} else {
			window.top.location.replace(lastProductPage);
		}
	}

	$(function() {
		language = $(document.body).attr('lang');
	});

	window.navigation = {
		baseURL: baseURL,
		staticPrefix: contentPrefix,
		javascriptURL: javascriptURL,
		staticURL: staticURL,
		dynamicURL: dynamicURL,
		updatableImgURL: updatableImgURL,
		language: language,
		gotoLastProductPage: gotoLastProductPage
	};

	return window.navigation;
});

